// removed by extract-text-webpack-plugin
module.exports = {"companies":"Companies__companies___2MnYe","companiesItem":"Companies__companiesItem___3tEmM"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/candidate/signUpMarketing/components/Companies.scss
// module id = 1793
// module chunks = 0